// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","container":"footer_container__tTpaG","block":"footer_block__1+fHu","text":"footer_text__9aNvQ"};